import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "write",
  "use": "write-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"write\"><title>write</title><g id=\"write_Layer_8\" data-name=\"Layer 8\"><path d=\"M3.3,17.2021A.6847.6847,0,0,0,3.4,17.1948L8.209,16.519,18.707,6.021,14.1113,1.4248l-10.48,10.48L2.57,16.2842a.74.74,0,0,0,.1768.6689A.75.75,0,0,0,3.3,17.2021Zm1.7163-5.268,7.3447-7.3447,3.1819,3.1818L8.198,15.116ZM17.293,6.021,16.25,7.0642,13.0679,3.8823l1.0434-1.0434ZM4.4482,12.78l2.8564,2.8564-3.6737.5162Z\" /><rect x=\"2\" y=\"18.5\" width=\"17\" height=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/write.svg
// module id = oGX+
// module chunks = 4